import React from 'react';
import PropTypes from 'prop-types';

const ToastTable = ({ data, onClose }) => {
  return (
    <>
      <div className='toast-table top-50 start-50 translate-middle'>
        <table className='table border mb-0 mt-3'>
          <thead>
            <tr>
              <th>Assignment</th>
              <th>Students Assigned</th>
              <th>Reason</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={`assign${index}`}>
                <td>{item.assignmentName}</td>
                <td>{item.studentsAssigned}</td>
                <td>{item.reason}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className="btn btn-castleRed mt-3" onClick={onClose}>
          OK
        </button>
      </div>
      <div className='modal-overlay'>
      </div>
    </>
  );
};

ToastTable.propTypes = {
  data: PropTypes.array,
  onClose: PropTypes.func
};

export default ToastTable;
